import type { FaireProductEntity } from "../../entity_types/product";

export const p_3ewm784he8: FaireProductEntity = {
  token: "p_3ewm784he8",
  type: "product",
  name: "Art Snob Gym Crew Socks",
  brandToken: "b_1fc44661",
  brandName: "Gumball Poodle",
  imageUrl: "https://cdn.faire.com/fastly/cae5e2406428b0585af17fbc341e550cf2422950f0d76fabc6e957405c04ca8a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f737d263060798895218bb1c32d41e5f2bc402d120cbafab354393c2b3536bb7.jpeg",
    "https://cdn.faire.com/fastly/606401ca699bd0caa426287e161af72b524a2a8c449ce23df30b6237967e8236.jpeg",
    "https://cdn.faire.com/fastly/391c5ce5ab59bd650a6891bed7080c0c4dc2d9b1ce982c89cc5843ec8e043e9b.jpeg",
    "https://cdn.faire.com/fastly/f2ecad71c1e5fabad2ff3cfc1f08f666ca97cf843bed5649318269c37806191f.jpeg",
    "https://cdn.faire.com/fastly/aaa24d14229694bb24e71131789ce0b30d83f4e82648c99094f40950b9286ad9.jpeg"
  ],
  priceDollars: 6.75,
  description: "If you like to explain the difference between Impressionism and Expressionism (and have strong opinions about it), you simply must don these socks.\n\nGumball Poodle is GPSR compliant! We will automatically be stickering all orders into the EU or Northern Ireland for GPSR compliance.\n\nIf you are in the UK but sell into the EU, we can provide you with the necessary stickers to put on products - be sure to tell us you need these when you place your order.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T05:28:12.180Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
